<div class="chart-container">
  <div class="score-horizontal-barchart-tooltip" [ngStyle]="{left: tooltipX + 'px', top: tooltipY + 'px', display: tooltipVisible}">
    <div class="tooltipHeading">{{ tooltipHeading }}<span *ngIf="tooltipDeletedMessage" class="tooltip-deleted-asterisk">*</span></div>
    <div class="tooltipData">
      <div class="tooltipDataText">Count</div>
      <div class="tooltipDataCount">{{ tooltipValue }}</div>
    </div>
    <div class="tooltipData">
      <div class="tooltipDataText">%</div>
      <div class="tooltipDataCount">{{ tooltipPercentage }}</div>
    </div>
    <div *ngIf="tooltipDeletedMessage" class="tooltipDeletedMessage">{{ tooltipDeletedMessage }}</div>
  </div>
  <div class="chart-canvas-wrapper">
    <canvas #chartCanvas class="graph"></canvas>
  </div>
</div>